import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import * as moment from "moment";
import "moment/locale/fr";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

moment.updateLocale("fr", {
  week: {
    dow: 1, // lundi
    doy: 4,
  },
  weekdaysShort: ["DIM", "LUN", "MAR", "MER", "JEU", "VEN", "SAM"],
  weekdaysMin: ["D", "L", "M", "M", "J", "V", "S"],
});

export function getBaseUrl() {
  return document.getElementsByTagName("base")[0].href;
}

const providers = [{ provide: "BASE_URL", useFactory: getBaseUrl, deps: [] }];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("ngsw-worker.js")
        .then((registration) => {})
        .catch((err) => {});
    }
  })
  .catch();
